<!--  -->
<template>
    <div class='content'>
        <div class="contents">
            <div class="crumbs">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item>
                        <span style="cursor: pointer;" @click="getBack"> {{ language['订单管理'][LT] }}</span>
                    </el-breadcrumb-item>
                    <el-breadcrumb-item> {{ language['订单详情'][LT] }}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div class="orderdetail">
                <div class="orderdetail_tip">
                    <div class="table_num">
                        <span>{{ orderdetail.table_id }}</span>
                        <span>{{ orderdetail.order_sn }}</span>
                    </div>
                    <div class="creat_time"> {{ language['结单时间：'][LT] }}{{ orderdetail.pay_time ? orderdetail.pay_time :
                        language['暂未结账'][LT] }}</div>
                </div>
                <div class="good_list">
                    <div class="good_item" v-for="(item, index) in goodList" :key="index">
                        <span class="good_name">{{ item.name }}</span>
                        <div class="good_num">
                            <span v-if="item.is_del == 1">已退单</span>
                            <span class="num">X{{ item.num }}</span>
                            <span class="price">￥{{ item.total_money }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="page">
                <el-pagination @current-change="getChange" :current-page="page" background layout="prev, pager, next"
                    :total="total"></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import language from '../../static/i18n/zh';

//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
        //这里存放数据
        return {
            order_sn: '', //订单号
            page: 1, //当前页数
            orderdetail: {}, //订单信息
            goodList: [], //商品列表,
            total: 0, //总数量
            allPage: 0,//总页数
            value1: '',
            input: '',
            tableData: [{
                date: 11111,
                name: '111111',
                address: 'zheshi'
            }]
        };
    },
    beforeRouteLeave(to,from,next){
      to.meta.keepAlive = true
      next(0)
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        // 订单详情
        getOrderDetail() {
            this.$post('64cc6771bc8b6', { order_sn: this.order_sn, page: this.page }).then(res => {
                if (res.code == 1) {
                    console.log('订单详情', res);
                    this.orderdetail = res.data.info;
                    this.goodList = res.data.order_goods_list.data;
                    this.allGoodNum = res.data.order_goods_list.last_page;
                    this.total = res.data.order_goods_list.total;
                }
            })
        },
        //切换内容
        getChange(event) {
            this.page = event;
            this.orderList = [];
            this.getOrderDetail();
        },
        getBack() {
            this.$router.back(-1);    //返回上一页
        }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        this.order_sn = this.$route.query.order_sn;
        this.getOrderDetail();
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
.content {
    background: #eee;
    padding: 20px;
}

.contents {
    background: #fff;
    height: calc(100vh - 40px);
    padding: 20px 10px;
    box-sizing: border-box;
    overflow-y: scroll;
    overflow: hidden;
}

.orderdetail {
    /* margin-top: 20px; */
    margin: 10px 20px 20px;
    border: 1px solid #eee;
}

.orderdetail_tip {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    font-weight: bold;
    background: rgb(243, 245, 255);
    line-height: 50px;
    padding: 0 20px;
}

.table_num span:nth-child(1) {
    font-size: 14px;
    margin-right: 20px;
}

.table_num span:nth-child(2) {}



.good_item {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    line-height: 50px;
    font-size: 14px;
    padding: 0 20px;
    box-sizing: border-box;
    border-top: 1px solid #eee;
}

.good_name {
    display: inline-block;
    width: 78%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}
.good_num span:nth-child(1) {
    color: red;
    margin-right: 30px;
}
.good_num span:nth-child(2) {
    margin-right: 30px;
}

.good_num span:nth-child(3) {
    display: inline-block;
    width: 100px;
    text-align: right;
    color: red;
    font-weight: bold;
}

.page {
    text-align: center;
    margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/view/orderDetail.vue